import React from 'react'
import styles from './Image.module.css'
import Image from '../../../../../Assets/image1.png'

const image = (props) => (
    <img className = {styles.Image} src = {Image}/>
)

export default image
